import { readImageSize } from "@/lib/image-size"

interface UploadedImage {
	original: File
	processed: File
	originalUrl: string | undefined
	processedUrl: string
}

// The stored size lets every reader reserve the image's box before it loads.
export const uploadedImageAttrs = async ({
	original,
	processed,
	originalUrl,
	processedUrl,
}: UploadedImage) => {
	const size = await readImageSize(originalUrl ? original : processed)
	return {
		src: originalUrl ?? processedUrl,
		"data-processed-src": processedUrl,
		"data-original-src": originalUrl,
		width: size?.width ?? null,
		height: size?.height ?? null,
	}
}
